import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class GeneralSettingService {

  constructor(private http: HttpClient) {}
  editGeneralSettig(body, generalSettingId) {
    return this.http.patch<ApiResponseModel>('/api/general-setting/' + generalSettingId, body);
  }

  createGeneralSettig(body) {
    return this.http.post<ApiResponseModel>('/api/general-setting/', body);
  }

  getGeneralSettingByID(generalSettingId) {
    return this.http.get<ApiResponseModel>('/api/general-setting/' + generalSettingId);
  }
}
